export const data = {
  alignTypes: [
    { value: "", label: "Brak" },
    { value: "align-left", label: "Do lewej" },
    { value: "align-center", label: "Do środka" },
    { value: "align-right", label: "Do prawej" }
  ],
  valignTypes: [
    { value: "", label: "Brak" },
    { value: "valign-top", label: "Do góry" },
    { value: "valign-center", label: "Do środka" },
    { value: "valign-bottom", label: "Do dodłu" }
  ],
  sideTypes: [
    { value: "", label: "Brak" },
    { value: "left-side", label: "Lewa" },
    { value: "right-side", label: "Prawa" }
  ],
  displaySizes: [
    { value: "display-1", label: "Rozmiar 1" },
    { value: "display-2", label: "Rozmiar 2" },
    { value: "display-3", label: "Rozmiar 3" },
    { value: "display-4", label: "Rozmiar 4" },
    { value: "display-5", label: "Rozmiar 5" },
    { value: "display-6", label: "Rozmiar 6" },
    { value: "display-7", label: "Rozmiar 7" }
  ],
  postTypes: [{ value: "", label: "Brak", value: "post", label: "Post" }],
  buttonTypes: [
    { value: "btn-default", label: "Domyślny" },
    { value: "btn-default-outline", label: "Domyślny z obrysem" },
    { value: "btn-black", label: "Czarny" },
    { value: "btn-black-outline", label: "Czarny z obrysem" },
    { value: "btn-white", label: "Biały" },
    { value: "btn-white-outline", label: "Biały z obrysem" },
    { value: "btn-primary", label: "Priorytet" },
    { value: "btn-primary-outline", label: "Priorytet z obrysem" }
  ],
  buttonSizes: [
    { value: "btn-sm", label: "Mały" },
    { value: "btn-md", label: "Średni" },
    { value: "btn-lg", label: "Duży" }
  ],
  containerTypes: [
    { value: "", label: "Brak" },
    { value: "fluid-size", label: "Szeroki kontener" },
    { value: "container-size", label: "Wydzielony kontener" },
    { value: "column-size", label: "Wydzielona kolumna" }
  ],
  tagTypes: [
    { value: "section", label: "section" },
    { value: "div", label: "div" },
    { value: "span", label: "span" }
  ],
  sizeTypes: [
    { value: "", label: "Brak" },
    { value: "size-xs", label: "Bardzo mały" },
    { value: "size-sm", label: "Mały" },
    { value: "size-md", label: "Średni" },
    { value: "size-lg", label: "Duży" },
    { value: "size-xl", label: "Bardzo duży" }
  ],
  colors: [
    { name: "#ffffff", color: "#ffffff" },
    { name: "#f8f5f5", color: "#f8f5f5" },
    { name: "#767676", color: "#767676" },
    { name: "#2b2b30", color: "#2b2b30" },
    { name: "#232323", color: "#232323" },
    { name: "#000000", color: "#000000" },
    { name: "#b47839", color: "#b47839" },
    { name: "#355746", color: "#355746" },
    { name: "#d3b896", color: "#d3b896" }
  ],
  blendTypes: [
    { value: "", label: "Brak" },
    { value: "normal", label: "normal" },
    { value: "multiply", label: "multiply" },
    { value: "screen", label: "screen" },
    { value: "overlay", label: "overlay" },
    { value: "darken", label: "darken" },
    { value: "lighten", label: "lighten" },
    { value: "color-dodge", label: "color-dodge" },
    { value: "color-burn", label: "color-burn" },
    { value: "hard-light", label: "hard-light" },
    { value: "hard-light", label: "hard-light" },
    { value: "difference", label: "difference" },
    { value: "exclusion", label: "exclusion" },
    { value: "hue", label: "hue" },
    { value: "saturation", label: "saturation" },
    { value: "color", label: "color" },
    { value: "luminosity", label: "luminosity" }
  ],
  styleTypes: [
    { label: "Brak", value: "" },
    { label: "Biały", value: "style-white" },
    { label: "Jasny", value: "style-light" },
    { label: "Ciemny", value: "style-dark" },
    { label: "Negatyw", value: "style-negative" },
    { label: "Priorytet", value: "style-primary" },
    { label: "Priorytet jasny", value: "style-primary-light" },
    { label: "Priorytet ciemny", value: "style-primary-dark" }
  ],
  iconSizes: [
    { value: "icon-sm", label: "Mała" },
    { value: "icon-md", label: "Średnia" },
    { value: "icon-lg", label: "Duża" }
  ],
  icons: [
    { value: "", label: "brak" },
    { value: "socicon-500px", label: "500px (socicon)" },
    { value: "socicon-8tracks", label: "8tracks (socicon)" },
    { value: "mbri-add-submenu", label: "add-submenu" },
    { value: "mobi-mbri-add-submenu", label: "add-submenu (mobile)" },
    { value: "socicon-airbnb", label: "airbnb (socicon)" },
    { value: "mbri-alert", label: "alert" },
    { value: "mobi-mbri-alert", label: "alert (mobile)" },
    { value: "mbri-align-center", label: "align-center" },
    { value: "mobi-mbri-align-center", label: "align-center (mobile)" },
    { value: "mbri-align-justify", label: "align-justify" },
    { value: "mobi-mbri-align-justify", label: "align-justify (mobile)" },
    { value: "mbri-align-left", label: "align-left" },
    { value: "mobi-mbri-align-left", label: "align-left (mobile)" },
    { value: "mbri-align-right", label: "align-right" },
    { value: "mobi-mbri-align-right", label: "align-right (mobile)" },
    { value: "socicon-alliance", label: "alliance (socicon)" },
    { value: "socicon-amazon", label: "amazon (socicon)" },
    { value: "socicon-amplement", label: "amplement (socicon)" },
    { value: "mbri-android", label: "android" },
    { value: "mobi-mbri-android", label: "android (mobile)" },
    { value: "socicon-android", label: "android (socicon)" },
    { value: "socicon-angellist", label: "angellist (socicon)" },
    { value: "mbri-apple", label: "apple" },
    { value: "mobi-mbri-apple", label: "apple (mobile)" },
    { value: "socicon-apple", label: "apple (socicon)" },
    { value: "socicon-appnet", label: "appnet (socicon)" },
    { value: "mbri-arrow-down", label: "arrow-down" },
    { value: "mobi-mbri-arrow-down", label: "arrow-down (mobile)" },
    { value: "mbri-arrow-next", label: "arrow-next" },
    { value: "mobi-mbri-arrow-next", label: "arrow-next (mobile)" },
    { value: "mbri-arrow-prev", label: "arrow-prev" },
    { value: "mobi-mbri-arrow-prev", label: "arrow-prev (mobile)" },
    { value: "mbri-arrow-up", label: "arrow-up" },
    { value: "mobi-mbri-arrow-up", label: "arrow-up (mobile)" },
    { value: "socicon-baidu", label: "baidu (socicon)" },
    { value: "socicon-bandcamp", label: "bandcamp (socicon)" },
    { value: "socicon-battlenet", label: "battlenet (socicon)" },
    { value: "socicon-beam", label: "beam (socicon)" },
    { value: "socicon-bebee", label: "bebee (socicon)" },
    { value: "socicon-bebo", label: "bebo (socicon)" },
    { value: "socicon-behance", label: "behance (socicon)" },
    { value: "socicon-blizzard", label: "blizzard (socicon)" },
    { value: "socicon-blogger", label: "blogger (socicon)" },
    { value: "mbri-bold", label: "bold" },
    { value: "mobi-mbri-bold", label: "bold (mobile)" },
    { value: "mbri-bookmark", label: "bookmark" },
    { value: "mobi-mbri-bookmark", label: "bookmark (mobile)" },
    { value: "mbri-bootstrap", label: "bootstrap" },
    { value: "mobi-mbri-bootstrap", label: "bootstrap (mobile)" },
    { value: "mbri-briefcase", label: "briefcase" },
    { value: "mobi-mbri-briefcase", label: "briefcase (mobile)" },
    { value: "mbri-browse", label: "browse" },
    { value: "mobi-mbri-browse", label: "browse (mobile)" },
    { value: "socicon-buffer", label: "buffer (socicon)" },
    { value: "mbri-bulleted-list", label: "bulleted-list" },
    { value: "mobi-mbri-bulleted-list", label: "bulleted-list (mobile)" },
    { value: "mbri-calendar", label: "calendar" },
    { value: "mobi-mbri-calendar", label: "calendar (mobile)" },
    { value: "mbri-camera", label: "camera" },
    { value: "mobi-mbri-camera", label: "camera (mobile)" },
    { value: "mbri-cart-add", label: "cart-add" },
    { value: "mobi-mbri-cart-add", label: "cart-add (mobile)" },
    { value: "mbri-cart-full", label: "cart-full" },
    { value: "mobi-mbri-cart-full", label: "cart-full (mobile)" },
    { value: "mbri-cash", label: "cash" },
    { value: "mobi-mbri-cash", label: "cash (mobile)" },
    { value: "mbri-change-style", label: "change-style" },
    { value: "mobi-mbri-change-style", label: "change-style (mobile)" },
    { value: "mbri-chat", label: "chat" },
    { value: "mobi-mbri-chat", label: "chat (mobile)" },
    { value: "socicon-chrome", label: "chrome (socicon)" },
    { value: "mbri-clock", label: "clock" },
    { value: "mobi-mbri-clock", label: "clock (mobile)" },
    { value: "mbri-close", label: "close" },
    { value: "mobi-mbri-close", label: "close (mobile)" },
    { value: "mbri-cloud", label: "cloud" },
    { value: "mobi-mbri-cloud", label: "cloud (mobile)" },
    { value: "mbri-code", label: "code" },
    { value: "mobi-mbri-code", label: "code (mobile)" },
    { value: "socicon-coderwall", label: "coderwall (socicon)" },
    { value: "mbri-contact-form", label: "contact-form" },
    { value: "mobi-mbri-contact-form", label: "contact-form (mobile)" },
    { value: "mbri-credit-card", label: "credit-card" },
    { value: "mobi-mbri-credit-card", label: "credit-card (mobile)" },
    { value: "socicon-curse", label: "curse (socicon)" },
    { value: "mbri-cursor-click", label: "cursor-click" },
    { value: "mobi-mbri-cursor-click", label: "cursor-click (mobile)" },
    { value: "mbri-cust-feedback", label: "cust-feedback" },
    { value: "mobi-mbri-cust-feedback", label: "cust-feedback (mobile)" },
    { value: "socicon-dailymotion", label: "dailymotion (socicon)" },
    { value: "mbri-database", label: "database" },
    { value: "mobi-mbri-database", label: "database (mobile)" },
    { value: "socicon-deezer", label: "deezer (socicon)" },
    { value: "socicon-delicious", label: "delicious (socicon)" },
    { value: "mbri-delivery", label: "delivery" },
    { value: "mobi-mbri-delivery", label: "delivery (mobile)" },
    { value: "mbri-desktop", label: "desktop" },
    { value: "mobi-mbri-desktop", label: "desktop (mobile)" },
    { value: "socicon-deviantart", label: "deviantart (socicon)" },
    { value: "mbri-devices", label: "devices" },
    { value: "mobi-mbri-devices", label: "devices (mobile)" },
    { value: "socicon-diablo", label: "diablo (socicon)" },
    { value: "socicon-digg", label: "digg (socicon)" },
    { value: "socicon-discord", label: "discord (socicon)" },
    { value: "socicon-disqus", label: "disqus (socicon)" },
    { value: "socicon-douban", label: "douban (socicon)" },
    { value: "mbri-down", label: "down" },
    { value: "mobi-mbri-down", label: "down (mobile)" },
    { value: "mbri-download", label: "download" },
    { value: "mobi-mbri-download", label: "download (mobile)" },
    { value: "mobi-mbri-download-2", label: "download-2 (mobile)" },
    { value: "mbri-drag-n-drop", label: "drag-n-drop" },
    { value: "mobi-mbri-drag-n-drop", label: "drag-n-drop (mobile)" },
    { value: "mobi-mbri-drag-n-drop-2", label: "drag-n-drop-2 (mobile)" },
    { value: "mbri-drag-n-drop2", label: "drag-n-drop2" },
    { value: "socicon-draugiem", label: "draugiem (socicon)" },
    { value: "socicon-dribbble", label: "dribbble (socicon)" },
    { value: "socicon-drupal", label: "drupal (socicon)" },
    { value: "socicon-ebay", label: "ebay (socicon)" },
    { value: "mbri-edit", label: "edit" },
    { value: "mobi-mbri-edit", label: "edit (mobile)" },
    { value: "mobi-mbri-edit-2", label: "edit-2 (mobile)" },
    { value: "mbri-edit2", label: "edit2" },
    { value: "socicon-ello", label: "ello (socicon)" },
    { value: "socicon-endomodo", label: "endomodo (socicon)" },
    { value: "socicon-envato", label: "envato (socicon)" },
    { value: "mbri-error", label: "error" },
    { value: "mobi-mbri-error", label: "error (mobile)" },
    { value: "socicon-etsy", label: "etsy (socicon)" },
    { value: "mbri-extension", label: "extension" },
    { value: "mobi-mbri-extension", label: "extension (mobile)" },
    { value: "socicon-facebook", label: "facebook (socicon)" },
    { value: "mbri-features", label: "features" },
    { value: "mobi-mbri-features", label: "features (mobile)" },
    { value: "socicon-feedburner", label: "feedburner (socicon)" },
    { value: "mbri-file", label: "file" },
    { value: "mobi-mbri-file", label: "file (mobile)" },
    { value: "socicon-filmweb", label: "filmweb (socicon)" },
    { value: "socicon-firefox", label: "firefox (socicon)" },
    { value: "mbri-flag", label: "flag" },
    { value: "mobi-mbri-flag", label: "flag (mobile)" },
    { value: "socicon-flattr", label: "flattr (socicon)" },
    { value: "socicon-flickr", label: "flickr (socicon)" },
    { value: "mbri-folder", label: "folder" },
    { value: "mobi-mbri-folder", label: "folder (mobile)" },
    { value: "socicon-formulr", label: "formulr (socicon)" },
    { value: "socicon-forrst", label: "forrst (socicon)" },
    { value: "socicon-foursquare", label: "foursquare (socicon)" },
    { value: "socicon-friendfeed", label: "friendfeed (socicon)" },
    { value: "mbri-gift", label: "gift" },
    { value: "mobi-mbri-gift", label: "gift (mobile)" },
    { value: "mbri-github", label: "github" },
    { value: "mobi-mbri-github", label: "github (mobile)" },
    { value: "socicon-github", label: "github (socicon)" },
    { value: "mbri-globe", label: "globe" },
    { value: "mobi-mbri-globe", label: "globe (mobile)" },
    { value: "mbri-globe-2", label: "globe-2" },
    { value: "mobi-mbri-globe-2", label: "globe-2 (mobile)" },
    { value: "socicon-goodreads", label: "goodreads (socicon)" },
    { value: "socicon-google", label: "google (socicon)" },
    { value: "socicon-google-scholar", label: "google (socicon)-scholar" },
    { value: "socicon-googlegroups", label: "googlegroups (socicon)" },
    { value: "socicon-googlephotos", label: "googlephotos (socicon)" },
    { value: "socicon-googleplus", label: "googleplus (socicon)" },
    { value: "socicon-grooveshark", label: "grooveshark (socicon)" },
    { value: "mbri-growing-chart", label: "growing-chart" },
    { value: "mobi-mbri-growing-chart", label: "growing-chart (mobile)" },
    { value: "mbri-hearth", label: "hearth" },
    { value: "mobi-mbri-hearth", label: "hearth (mobile)" },
    { value: "socicon-hearthstone", label: "hearthstone (socicon)" },
    { value: "socicon-hellocoton", label: "hellocoton (socicon)" },
    { value: "mbri-help", label: "help" },
    { value: "mobi-mbri-help", label: "help (mobile)" },
    { value: "socicon-heroes", label: "heroes (socicon)" },
    { value: "socicon-hitbox", label: "hitbox (socicon)" },
    { value: "mbri-home", label: "home" },
    { value: "mobi-mbri-home", label: "home (mobile)" },
    { value: "socicon-horde", label: "horde (socicon)" },
    { value: "mbri-hot-cup", label: "hot-cup" },
    { value: "mobi-mbri-hot-cup", label: "hot-cup (mobile)" },
    { value: "socicon-houzz", label: "houzz (socicon)" },
    { value: "socicon-icq", label: "icq (socicon)" },
    { value: "mbri-idea", label: "idea" },
    { value: "mobi-mbri-idea", label: "idea (mobile)" },
    { value: "socicon-identica", label: "identica (socicon)" },
    { value: "mbri-image-gallery", label: "image-gallery" },
    { value: "mobi-mbri-image-gallery", label: "image-gallery (mobile)" },
    { value: "mbri-image-slider", label: "image-slider" },
    { value: "mobi-mbri-image-slider", label: "image-slider (mobile)" },
    { value: "socicon-imdb", label: "imdb (socicon)" },
    { value: "mbri-info", label: "info" },
    { value: "mobi-mbri-info", label: "info (mobile)" },
    { value: "socicon-instagram", label: "instagram (socicon)" },
    { value: "socicon-issuu", label: "issuu (socicon)" },
    { value: "socicon-istock", label: "istock (socicon)" },
    { value: "mbri-italic", label: "italic" },
    { value: "mobi-mbri-italic", label: "italic (mobile)" },
    { value: "socicon-itunes", label: "itunes (socicon)" },
    { value: "mbri-key", label: "key" },
    { value: "mobi-mbri-key", label: "key (mobile)" },
    { value: "socicon-keybase", label: "keybase (socicon)" },
    { value: "socicon-lanyrd", label: "lanyrd (socicon)" },
    { value: "mbri-laptop", label: "laptop" },
    { value: "mobi-mbri-laptop", label: "laptop (mobile)" },
    { value: "socicon-lastfm", label: "lastfm (socicon)" },
    { value: "mbri-layers", label: "layers" },
    { value: "mobi-mbri-layers", label: "layers (mobile)" },
    { value: "mbri-left", label: "left" },
    { value: "mobi-mbri-left", label: "left (mobile)" },
    { value: "mbri-left-right", label: "left-right" },
    { value: "mobi-mbri-left-right", label: "left-right (mobile)" },
    { value: "mbri-letter", label: "letter" },
    { value: "mobi-mbri-letter", label: "letter (mobile)" },
    { value: "mbri-like", label: "like" },
    { value: "mobi-mbri-like", label: "like (mobile)" },
    { value: "socicon-line", label: "line (socicon)" },
    { value: "mbri-link", label: "link" },
    { value: "mobi-mbri-link", label: "link (mobile)" },
    { value: "socicon-linkedin", label: "linkedin (socicon)" },
    { value: "socicon-livejournal", label: "livejournal (socicon)" },
    { value: "mbri-lock", label: "lock" },
    { value: "mobi-mbri-lock", label: "lock (mobile)" },
    { value: "mbri-login", label: "login" },
    { value: "mobi-mbri-login", label: "login (mobile)" },
    { value: "mbri-logout", label: "logout" },
    { value: "mobi-mbri-logout", label: "logout (mobile)" },
    { value: "socicon-lyft", label: "lyft (socicon)" },
    { value: "socicon-macos", label: "macos (socicon)" },
    { value: "mbri-magic-stick", label: "magic-stick" },
    { value: "mobi-mbri-magic-stick", label: "magic-stick (mobile)" },
    { value: "socicon-mail", label: "mail (socicon)" },
    { value: "mbri-map-pin", label: "map-pin" },
    { value: "mobi-mbri-map-pin", label: "map-pin (mobile)" },
    { value: "socicon-medium", label: "medium (socicon)" },
    { value: "socicon-meetup", label: "meetup (socicon)" },
    { value: "mbri-menu", label: "menu" },
    { value: "mobi-mbri-menu", label: "menu (mobile)" },
    { value: "socicon-mixcloud", label: "mixcloud (socicon)" },
    { value: "mbri-mobile", label: "mobile" },
    { value: "mobi-mbri-mobile", label: "mobile (mobile)" },
    { value: "mobi-mbri-mobile-2", label: "mobile-2 (mobile)" },
    {
      value: "mobi-mbri-mobile-horizontal",
      label: "mobile-horizontal (mobile)"
    },
    { value: "mbri-mobile2", label: "mobile2" },
    { value: "mbri-mobirise", label: "mobirise" },
    { value: "mobi-mbri-mobirise", label: "mobirise (mobile)" },
    { value: "socicon-modelmayhem", label: "modelmayhem (socicon)" },
    { value: "mbri-more-horizontal", label: "more-horizontal" },
    { value: "mobi-mbri-more-horizontal", label: "more-horizontal (mobile)" },
    { value: "mbri-more-vertical", label: "more-vertical" },
    { value: "mobi-mbri-more-vertical", label: "more-vertical (mobile)" },
    { value: "socicon-mumble", label: "mumble (socicon)" },
    { value: "mbri-music", label: "music" },
    { value: "mobi-mbri-music", label: "music (mobile)" },
    { value: "socicon-myspace", label: "myspace (socicon)" },
    { value: "mbri-new-file", label: "new-file" },
    { value: "mobi-mbri-new-file", label: "new-file (mobile)" },
    { value: "socicon-newsvine", label: "newsvine (socicon)" },
    { value: "socicon-nintendo", label: "nintendo (socicon)" },
    { value: "mbri-numbered-list", label: "numbered-list" },
    { value: "mobi-mbri-numbered-list", label: "numbered-list (mobile)" },
    { value: "socicon-odnoklassniki", label: "odnoklassniki (socicon)" },
    { value: "mbri-opened-folder", label: "opened-folder" },
    { value: "mobi-mbri-opened-folder", label: "opened-folder (mobile)" },
    { value: "socicon-openid", label: "openid (socicon)" },
    { value: "socicon-opera", label: "opera (socicon)" },
    { value: "socicon-outlook", label: "outlook (socicon)" },
    { value: "socicon-overwatch", label: "overwatch (socicon)" },
    { value: "mbri-pages", label: "pages" },
    { value: "mobi-mbri-pages", label: "pages (mobile)" },
    { value: "mbri-paper-plane", label: "paper-plane" },
    { value: "mobi-mbri-paper-plane", label: "paper-plane (mobile)" },
    { value: "mbri-paperclip", label: "paperclip" },
    { value: "mobi-mbri-paperclip", label: "paperclip (mobile)" },
    { value: "socicon-patreon", label: "patreon (socicon)" },
    { value: "socicon-paypal", label: "paypal (socicon)" },
    { value: "socicon-periscope", label: "periscope (socicon)" },
    { value: "socicon-persona", label: "persona (socicon)" },
    { value: "mobi-mbri-phone", label: "phone (mobile)" },
    { value: "mbri-photo", label: "photo" },
    { value: "mobi-mbri-photo", label: "photo (mobile)" },
    { value: "mbri-photos", label: "photos" },
    { value: "mobi-mbri-photos", label: "photos (mobile)" },
    { value: "mbri-pin", label: "pin" },
    { value: "mobi-mbri-pin", label: "pin (mobile)" },
    { value: "socicon-pinterest", label: "pinterest (socicon)" },
    { value: "mbri-play", label: "play" },
    { value: "mobi-mbri-play", label: "play (mobile)" },
    { value: "socicon-play", label: "play (socicon)" },
    { value: "socicon-player", label: "player (socicon)" },
    { value: "socicon-playstation", label: "playstation (socicon)" },
    { value: "mbri-plus", label: "plus" },
    { value: "mobi-mbri-plus", label: "plus (mobile)" },
    { value: "socicon-pocket", label: "pocket (socicon)" },
    { value: "mbri-preview", label: "preview" },
    { value: "mobi-mbri-preview", label: "preview (mobile)" },
    { value: "mbri-print", label: "print" },
    { value: "mobi-mbri-print", label: "print (mobile)" },
    { value: "mbri-protect", label: "protect" },
    { value: "mobi-mbri-protect", label: "protect (mobile)" },
    { value: "socicon-qq", label: "qq (socicon)" },
    { value: "mbri-question", label: "question" },
    { value: "mobi-mbri-question", label: "question (mobile)" },
    { value: "socicon-quora", label: "quora (socicon)" },
    { value: "mbri-quote-left", label: "quote-left" },
    { value: "mobi-mbri-quote-left", label: "quote-left (mobile)" },
    { value: "mbri-quote-right", label: "quote-right" },
    { value: "mobi-mbri-quote-right", label: "quote-right (mobile)" },
    { value: "socicon-raidcall", label: "raidcall (socicon)" },
    { value: "socicon-ravelry", label: "ravelry (socicon)" },
    { value: "socicon-reddit", label: "reddit (socicon)" },
    { value: "mbri-redo", label: "redo" },
    { value: "mobi-mbri-redo", label: "redo (mobile)" },
    { value: "mbri-refresh", label: "refresh" },
    { value: "mobi-mbri-refresh", label: "refresh (mobile)" },
    { value: "socicon-renren", label: "renren (socicon)" },
    { value: "socicon-researchgate", label: "researchgate (socicon)" },
    { value: "socicon-residentadvisor", label: "residentadvisor (socicon)" },
    { value: "mbri-responsive", label: "responsive" },
    { value: "mobi-mbri-responsive", label: "responsive (mobile)" },
    { value: "mobi-mbri-responsive-2", label: "responsive-2 (mobile)" },
    { value: "socicon-reverbnation", label: "reverbnation (socicon)" },
    { value: "mbri-right", label: "right" },
    { value: "mobi-mbri-right", label: "right (mobile)" },
    { value: "mbri-rocket", label: "rocket" },
    { value: "mobi-mbri-rocket", label: "rocket (mobile)" },
    { value: "socicon-rss", label: "rss (socicon)" },
    { value: "mbri-sad-face", label: "sad-face" },
    { value: "mobi-mbri-sad-face", label: "sad-face (mobile)" },
    { value: "mbri-sale", label: "sale" },
    { value: "mobi-mbri-sale", label: "sale (mobile)" },
    { value: "mbri-save", label: "save" },
    { value: "mobi-mbri-save", label: "save (mobile)" },
    { value: "mbri-search", label: "search" },
    { value: "mobi-mbri-search", label: "search (mobile)" },
    { value: "mbri-setting", label: "setting" },
    { value: "mobi-mbri-setting", label: "setting (mobile)" },
    { value: "mobi-mbri-setting-2", label: "setting-2 (mobile)" },
    { value: "mobi-mbri-setting-3", label: "setting-3 (mobile)" },
    { value: "mbri-setting2", label: "setting2" },
    { value: "mbri-setting3", label: "setting3" },
    { value: "mbri-share", label: "share" },
    { value: "mobi-mbri-share", label: "share (mobile)" },
    { value: "socicon-sharethis", label: "sharethis (socicon)" },
    { value: "mbri-shopping-bag", label: "shopping-bag" },
    { value: "mobi-mbri-shopping-bag", label: "shopping-bag (mobile)" },
    { value: "mbri-shopping-basket", label: "shopping-basket" },
    { value: "mobi-mbri-shopping-basket", label: "shopping-basket (mobile)" },
    { value: "mbri-shopping-cart", label: "shopping-cart" },
    { value: "mobi-mbri-shopping-cart", label: "shopping-cart (mobile)" },
    { value: "mbri-sites", label: "sites" },
    { value: "mobi-mbri-sites", label: "sites (mobile)" },
    { value: "socicon-skype", label: "skype (socicon)" },
    { value: "socicon-slideshare", label: "slideshare (socicon)" },
    { value: "mbri-smile-face", label: "smile-face" },
    { value: "mobi-mbri-smile-face", label: "smile-face (mobile)" },
    { value: "socicon-smugmug", label: "smugmug (socicon)" },
    { value: "socicon-snapchat", label: "snapchat (socicon)" },
    { value: "socicon-songkick", label: "songkick (socicon)" },
    { value: "socicon-soundcloud", label: "soundcloud (socicon)" },
    { value: "mbri-speed", label: "speed" },
    { value: "mobi-mbri-speed", label: "speed (mobile)" },
    { value: "socicon-spotify", label: "spotify (socicon)" },
    { value: "socicon-stackexchange", label: "stackexchange (socicon)" },
    { value: "socicon-stackoverflow", label: "stackoverflow (socicon)" },
    { value: "mbri-star", label: "star" },
    { value: "mobi-mbri-star", label: "star (mobile)" },
    { value: "socicon-starcraft", label: "starcraft (socicon)" },
    { value: "socicon-stayfriends", label: "stayfriends (socicon)" },
    { value: "socicon-steam", label: "steam (socicon)" },
    { value: "socicon-storehouse", label: "storehouse (socicon)" },
    { value: "socicon-strava", label: "strava (socicon)" },
    { value: "socicon-streamjar", label: "streamjar (socicon)" },
    { value: "socicon-stumbleupon", label: "stumbleupon (socicon)" },
    { value: "mbri-success", label: "success" },
    { value: "mobi-mbri-success", label: "success (mobile)" },
    { value: "mbri-sun", label: "sun" },
    { value: "mobi-mbri-sun", label: "sun (mobile)" },
    { value: "mbri-sun2", label: "sun2" },
    { value: "mobi-mbri-sun2", label: "sun2 (mobile)" },
    { value: "socicon-swarm", label: "swarm (socicon)" },
    { value: "mbri-tablet", label: "tablet" },
    { value: "mobi-mbri-tablet", label: "tablet (mobile)" },
    { value: "mbri-tablet-vertical", label: "tablet-vertical" },
    { value: "mobi-mbri-tablet-vertical", label: "tablet-vertical (mobile)" },
    { value: "mbri-target", label: "target" },
    { value: "mobi-mbri-target", label: "target (mobile)" },
    { value: "socicon-teamspeak", label: "teamspeak (socicon)" },
    { value: "socicon-teamviewer", label: "teamviewer (socicon)" },
    { value: "socicon-technorati", label: "technorati (socicon)" },
    { value: "socicon-telegram", label: "telegram (socicon)" },
    { value: "mbri-timer", label: "timer" },
    { value: "mobi-mbri-timer", label: "timer (mobile)" },
    { value: "mbri-to-ftp", label: "to-ftp" },
    { value: "mobi-mbri-to-ftp", label: "to-ftp (mobile)" },
    { value: "mbri-to-local-drive", label: "to-local-drive" },
    { value: "mobi-mbri-to-local-drive", label: "to-local-drive (mobile)" },
    { value: "mbri-touch", label: "touch" },
    { value: "mobi-mbri-touch", label: "touch (mobile)" },
    { value: "mbri-touch-swipe", label: "touch-swipe" },
    { value: "mobi-mbri-touch-swipe", label: "touch-swipe (mobile)" },
    { value: "mbri-trash", label: "trash" },
    { value: "mobi-mbri-trash", label: "trash (mobile)" },
    { value: "socicon-tripadvisor", label: "tripadvisor (socicon)" },
    { value: "socicon-tripit", label: "tripit (socicon)" },
    { value: "socicon-triplej", label: "triplej (socicon)" },
    { value: "socicon-tumblr", label: "tumblr (socicon)" },
    { value: "socicon-twitch", label: "twitch (socicon)" },
    { value: "socicon-twitter", label: "twitter (socicon)" },
    { value: "socicon-uber", label: "uber (socicon)" },
    { value: "mbri-underline", label: "underline" },
    { value: "mobi-mbri-underline", label: "underline (mobile)" },
    { value: "mbri-undo", label: "undo" },
    { value: "mobi-mbri-undo", label: "undo (mobile)" },
    { value: "mbri-unlink", label: "unlink" },
    { value: "mobi-mbri-unlink", label: "unlink (mobile)" },
    { value: "mbri-unlock", label: "unlock" },
    { value: "mobi-mbri-unlock", label: "unlock (mobile)" },
    { value: "mbri-up", label: "up" },
    { value: "mobi-mbri-up", label: "up (mobile)" },
    { value: "mbri-up-down", label: "up-down" },
    { value: "mobi-mbri-up-down", label: "up-down (mobile)" },
    { value: "mbri-update", label: "update" },
    { value: "mobi-mbri-update", label: "update (mobile)" },
    { value: "mbri-upload", label: "upload" },
    { value: "mobi-mbri-upload", label: "upload (mobile)" },
    { value: "mobi-mbri-upload-2", label: "upload-2 (mobile)" },
    { value: "mbri-user", label: "user" },
    { value: "mobi-mbri-user", label: "user (mobile)" },
    { value: "mobi-mbri-user-2", label: "user-2 (mobile)" },
    { value: "mbri-user2", label: "user2" },
    { value: "mbri-users", label: "users" },
    { value: "mobi-mbri-users", label: "users (mobile)" },
    { value: "socicon-ventrilo", label: "ventrilo (socicon)" },
    { value: "socicon-viadeo", label: "viadeo (socicon)" },
    { value: "socicon-viber", label: "viber (socicon)" },
    { value: "mbri-video", label: "video" },
    { value: "mobi-mbri-video", label: "video (mobile)" },
    { value: "mbri-video-play", label: "video-play" },
    { value: "mobi-mbri-video-play", label: "video-play (mobile)" },
    { value: "socicon-viewbug", label: "viewbug (socicon)" },
    { value: "socicon-vimeo", label: "vimeo (socicon)" },
    { value: "socicon-vine", label: "vine (socicon)" },
    { value: "socicon-vkontakte", label: "vkontakte (socicon)" },
    { value: "socicon-warcraft", label: "warcraft (socicon)" },
    { value: "mbri-watch", label: "watch" },
    { value: "mobi-mbri-watch", label: "watch (mobile)" },
    { value: "mbri-website-theme", label: "website-theme" },
    { value: "mobi-mbri-website-theme", label: "website-theme (mobile)" },
    { value: "mobi-mbri-website-theme-2", label: "website-theme-2 (mobile)" },
    { value: "socicon-wechat", label: "wechat (socicon)" },
    { value: "socicon-weibo", label: "weibo (socicon)" },
    { value: "socicon-whatsapp", label: "whatsapp (socicon)" },
    { value: "mbri-wifi", label: "wifi" },
    { value: "mobi-mbri-wifi", label: "wifi (mobile)" },
    { value: "socicon-wikipedia", label: "wikipedia (socicon)" },
    { value: "mbri-windows", label: "windows" },
    { value: "mobi-mbri-windows", label: "windows (mobile)" },
    { value: "socicon-windows", label: "windows (socicon)" },
    { value: "socicon-wordpress", label: "wordpress (socicon)" },
    { value: "socicon-wykop", label: "wykop (socicon)" },
    { value: "socicon-xbox", label: "xbox (socicon)" },
    { value: "socicon-xing", label: "xing (socicon)" },
    { value: "socicon-yahoo", label: "yahoo (socicon)" },
    { value: "socicon-yammer", label: "yammer (socicon)" },
    { value: "socicon-yandex", label: "yandex (socicon)" },
    { value: "socicon-yelp", label: "yelp (socicon)" },
    { value: "socicon-younow", label: "younow (socicon)" },
    { value: "socicon-youtube", label: "youtube (socicon)" },
    { value: "socicon-zapier", label: "zapier (socicon)" },
    { value: "socicon-zerply", label: "zerply (socicon)" },
    { value: "socicon-zomato", label: "zomato (socicon)" },
    { value: "mobi-mbri-zoom-in", label: "zoom-in (mobile)" },
    { value: "mbri-zoom-out", label: "zoom-out" },
    { value: "mobi-mbri-zoom-out", label: "zoom-out (mobile)" },
    { value: "socicon-zynga", label: "zynga (socicon)" }
  ]
};

export default data;
